export const dispatch = Symbol('dispatch')
